export const fetchTrackFromXmlFeed = async (metadataUrl, signal) => {
	const response = await fetch(metadataUrl, {
		cache: "no-store",
		signal,
	});

	if (response.status === 204) {
		console.warn("No content available from metadata feed");
	}

	if (!response.ok) {
		throw new Error(`Metadata request failed with ${response.status}`);
	}

	const xmlText = await response.text();
	const xml = new window.DOMParser().parseFromString(xmlText, "application/xml");

	if (xml.getElementsByTagName("parsererror").length > 0) {
		throw new Error("Unable to parse metadata feed");
	}

	const artistNode = xml.getElementsByTagName("artist")[0];
	const titleNode = xml.getElementsByTagName("title")[0];
	const artist = artistNode?.textContent?.trim() || "";
	const title = titleNode?.textContent?.trim() || "";

	if (artist && title) {
		return `${artist} - ${title}`;
	}

	return title || artist;
};

export const fetchTrackFromJsonFeed = async (metadataUrl, signal) => {
	const response = await fetch(metadataUrl, {
		cache: "no-store",
		signal,
	});

	if (response.status === 204) {
		console.warn("No content available from metadata feed");
	}

	if (!response.ok) {
		throw new Error(`Metadata request failed with ${response.status}`);
	}

	const payload = await response.json();
	if (payload.track) {
		return String(payload.track).trim();
	}

	if (payload.artist && payload.title) {
		const artist = String(payload.artist).trim();
		const title = String(payload.title).trim();
		if (artist && title) {
			return `${artist} - ${title}`;
		}
		return title || artist;
	}

	const firstSong = Array.isArray(payload.songs) ? payload.songs[0] : null;
	if (firstSong) {
		const artist = (firstSong.artist || "").trim();
		const title = (firstSong.song || firstSong.title || "").trim();
		if (artist && title) {
			return `${artist} - ${title}`;
		}
		return title || artist;
	}

	return "";
};

export const fetchTrackFromTextFeed = async (metadataUrl, signal) => {
	const response = await fetch(metadataUrl, {
		cache: "no-store",
		signal,
	});

	if (response.status === 204) {
		console.warn("No content available from metadata feed");
	}

	if (!response.ok) {
		throw new Error(`Metadata request failed with ${response.status}`);
	}
	return (await response.text()).trim();
};

export function getFilteredStations(STATIONS, search) {
	return STATIONS.filter((s) =>
		(s.name + " " + s.description)
			.toLowerCase()
			.includes(search.toLowerCase())
	).sort((a, b) => a.name.localeCompare(b.name));
}

export function updateMediaSessionMetadata(isPlaying, currentStation, nowPlayingTrack) {
	if (!isPlaying || !currentStation) {
		if (navigator.mediaSession) {
			navigator.mediaSession.metadata = null;
		}
		return;
	}

	const artist = nowPlayingTrack && nowPlayingTrack.includes(' - ')
		? nowPlayingTrack.split(' - ')[0]
		: currentStation.name;
	const trackTitle = nowPlayingTrack && nowPlayingTrack.includes(' - ')
		? nowPlayingTrack.split(' - ')[1]
		: nowPlayingTrack || currentStation.name;

	let artwork = undefined;
	if (currentStation.image) {
		let imgUrl = currentStation.image;
		if (!/^https?:\/\//.test(imgUrl)) {
			imgUrl = (window.location.origin || '') + (imgUrl.startsWith('/') ? imgUrl : '/' + imgUrl);
		}
		artwork = [
			{src: imgUrl, sizes: '512x512', type: 'image/png'},
			{src: imgUrl, sizes: '192x192', type: 'image/png'},
		];
	}

	if (navigator.mediaSession) {
		navigator.mediaSession.metadata = new window.MediaMetadata({
			title: trackTitle,
			artist: artist,
			album: currentStation.name,
			artwork: artwork,
		});
	}
}